import { Box, BoxProps } from "@bigcommerce/big-design";
import styled from "styled-components";

interface StyledModalWrapperProps extends BoxProps {
    maxWidth?: string;
}

export const StyledModalWrapper = styled(Box)<StyledModalWrapperProps>`
  max-width: ${(props) => props.maxWidth};
`;